import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { fetchUserProfile } from '../../../actions/Auth';
import {
  APIcreateCollectionGroupGroup,
  APIupdateCollectionGroupGroup,
} from '../../../api/Collections';

import ErrorBoundary from '../../ErrorBoundary';

class CollectionGroupGroupEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      saving: false,
      errors: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSaveCollectionGroupGroup = this.handleSaveCollectionGroupGroup.bind(this);
  }

  componentDidMount() {
    const {
      collectionGroupGroup,
    } = this.props;

    if (collectionGroupGroup) {
      this.setState({
        name: collectionGroupGroup.name,
      });
    }
  }

  validateForm() {
    const {
      name,
    } = this.state;
    const errors = {};

    if (!name) {
      errors.name = 'This field is required';
    }

    this.setState({ errors });

    if (Object.keys(errors).length > 0) {
      return false;
    }

    return true;
  }

  handleChange(e) {
    const {
      name,
      value,
    } = e.target;
    this.setState({ [name]: value });
  }

  handleKeyPress(e) {
    e.persist();
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSaveCollectionGroupGroup();
    }
  }

  handleSaveCollectionGroupGroup() {
    if (!this.validateForm()) {
      return;
    }

    const { name } = this.state;
    const {
      dispatch,
      collectionGroupGroup,
      handleClose,
      notificationCallback,
    } = this.props;

    this.setState({ saving: true });

    if (collectionGroupGroup) {
      const updatedCollectionGroupGroup = Object.assign({}, collectionGroupGroup);
      updatedCollectionGroupGroup.name = name;

      APIupdateCollectionGroupGroup({ collectionGroupGroup: updatedCollectionGroupGroup })
        .then((response) => {
          if (response.data) {
            dispatch(fetchUserProfile()).then(() => {
              notificationCallback(response.data).then(() => {
                handleClose();
              });
            });
          }
        });
    } else {
      APIcreateCollectionGroupGroup({ collectionGroupGroup: { name } })
        .then((response) => {
          dispatch(fetchUserProfile()).then(() => {
            notificationCallback(response.data).then(() => {
              handleClose();
            });
          });
        });
    }
  }

  render() {
    const {
      name,
      errors,
      saving,
    } = this.state;
    const {
      intl,
      collectionGroupGroup,
      handleClose,
    } = this.props;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose} className="modal-header-center">
          {collectionGroupGroup ? (
            intl.formatMessage({ defaultMessage: 'Edit Collection Group Title' })
          ) : (
            intl.formatMessage({ defaultMessage: 'New Collection Group Title' })
          )}
        </ModalHeader>
        <ModalBody>
          <Form
            className="new-collection-form"
            onKeyPress={this.handleKeyPress}
          >
            <FormGroup>
              <Label for="inpName">
                {intl.formatMessage({ defaultMessage: 'Collection group title' })}
              </Label>
              <Input
                type="text"
                name="name"
                id="inpName"
                placeholder={intl.formatMessage({ defaultMessage: 'Collection group title' })}
                autoFocus={true}
                defaultValue={name}
                onChange={this.handleChange}
                invalid={errors.name !== undefined}
              />
              <FormFeedback>
                {errors.name}
              </FormFeedback>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            disabled={saving}
            onClick={handleClose}
          >
            {intl.formatMessage({ defaultMessage: 'Cancel' })}
          </Button>
          {' '}
          <Button
            color="primary"
            disabled={saving}
            onClick={this.handleSaveCollectionGroupGroup}
          >
            {saving ? intl.formatMessage({ defaultMessage: 'Saving...' }) : intl.formatMessage({ defaultMessage: 'Save' })}
          </Button>
        </ModalFooter>
      </ErrorBoundary>
    );
  }
}

CollectionGroupGroupEditModal.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  collectionGroupGroup: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  notificationCallback: PropTypes.func,
};

CollectionGroupGroupEditModal.defaultProps = {
  collectionGroupGroup: null,
  notificationCallback: () => {},
};

export default connect()(injectIntl(CollectionGroupGroupEditModal));
